import React, { useEffect, useState } from 'react';
import { useParams, useHistory  } from 'react-router';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ImageTable from '../Components/database/images-table/images-table.component'
import ManuscriptTable from '../Components/database/manuscript-table/manuscript-table.component';
import PrintTable from '../Components/database/print-table/print-table.component';
import Grid from '@material-ui/core/Grid';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { Link } from 'react-router-dom';
import Searchbar from '../Components/database/searchbar/searchbar.component';
import { InputBase } from '@material-ui/core';
import { addImage, addManuscript, addPrint, deleteSingleImage, deleteSingleManuscript, deleteSinglePrint, updateSingleImage, updateSingleManuscript, updateSinglePrint, trackUpdateImage } from "../Components/database/api"
import axiosClient from "../Service/api"
import SimpleAccordion from '../Components/database/accordion-list/accordion.list.component';
import swal from '@sweetalert/with-react';
import "../Components/database/directorydatabase/alertbutton.styles.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
        {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,

  },
  indicator: {
    backgroundColor: "#A92820",
  },
  label: {
    fontFamily: 'Montserrat',
    color: 'black',
    fontWeight: '600',
    fontSize: '14px',
    '&:focus': {
      color: '#A92820',
    },
    '&:hover': {
      color: 'black',
      textDecoration: 'none',
    }
  }

}));

export default function NavTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [images, setImages] = React.useState([])
  const [manuscripts, setManuscripts] = React.useState([])
  const [prints, setPrints] = React.useState([])



  const {record_id} = useParams()

  //Setting logic to allow searchbar

//Setting logic to allow searchbar

const [searchParam, setSearchParam] = useState({
  searchFieldValue: "",
});
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");

const [errorFrom, setErrorFrom] = useState("");
const [errorTo, setErrorTo] = useState("");

  // After initial state for the search parameter, creation of a "copy" for every single documents' array

  const [imagesSlice, setImagesSlice] = useState([]);
  const [manuscriptsSlice, setManuscriptsSlice] = useState([]);
  const [printsSlice, setPrintsSlice] = useState([]); 

 // Creation of the filtering logic
 const handleFiltering = async () => {
  if (searchParam.searchFieldValue === "" && ('' + fromDate) === "" && ('' + toDate) === "") {
    setImagesSlice(images);
    setManuscriptsSlice(manuscripts);
    setPrintsSlice(prints);
  } else if (searchParam.searchFieldValue !== "" && ('' + fromDate) === "" && ('' + toDate) === "") {
    setImagesSlice(
      images.filter(el => {
        return (
          el.documentTitle
            .toLowerCase()
            .includes(searchParam.searchFieldValue.toLowerCase()) ||
          el.typology
            .toLowerCase()
            .includes(searchParam.searchFieldValue.toLowerCase()) ||
          (el.date + '').includes(searchParam.searchFieldValue) ||
          el.artist
            .toLowerCase()
            .includes(searchParam.searchFieldValue.toLowerCase())
        );
      })
    )
    setManuscriptsSlice(
      manuscripts.filter(el => {
       
        return (
          el.documentTitle
            .toLowerCase()
            .includes(searchParam.searchFieldValue.toLowerCase()) ||
          el.typology
            .toLowerCase()
            .includes(searchParam.searchFieldValue.toLowerCase()) ||
          el.dateOfWriting
            .toLowerCase()
            .includes(searchParam.searchFieldValue.toLowerCase()) ||
          el.author
            .toLowerCase()
            .includes(searchParam.searchFieldValue.toLowerCase()) ||
          el.language
            .toLowerCase()
            .includes(searchParam.searchFieldValue.toLowerCase())
        );
      })
    ) 
    setPrintsSlice(
      prints.filter(el => {
        return (
          el.documentTitle
            .toLowerCase()
            .includes(searchParam.searchFieldValue.toLowerCase()) ||
            (el.date + '').includes(searchParam.searchFieldValue) ||
            el.typology.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) ||
            el.author.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) ||
            el.language.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase())
        );
      })
    );
  } else if (searchParam.searchFieldValue !== "" && ('' + fromDate) !== "" && ('' + toDate) === "") {
    setImagesSlice(images.filter((el) => {
     return (el.documentTitle.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) ||
      el.typology.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) ||
      (el.date + '').includes(searchParam.searchFieldValue) && ('' + el.date) >= ('' + fromDate) ||
      el.artist.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >=('' + fromDate))
    }))
    setManuscriptsSlice(manuscripts.filter((el) => {
      return (el.documentTitle.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && el.dateOfWriting >= ('' + fromDate) ||
      ('' + el.dateOfWriting).includes(searchParam.searchFieldValue) && ('' + el.dateOfWriting) >= ('' + fromDate) ||
      el.typology.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && el.dateOfWriting >= ('' + fromDate) ||
      el.author.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && el.dateOfWriting >= ('' + fromDate) ||
      el.language.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && el.dateOfWriting >= ('' + fromDate))
    }))
    setPrintsSlice(prints.filter((el) => {
      return (el.documentTitle.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) ||
      el.typology.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) ||
      ('' + el.date).includes(searchParam.searchFieldValue) && ('' + el.date) >= ('' + fromDate) ||
      el.author.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) ||
      el.language.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate))
    }))
  } else if (searchParam.searchFieldValue !== "" && ('' + fromDate) === "" && ('' + toDate) !== "") {
    setImagesSlice(images.filter((el) => {
      return(el.documentTitle.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) <= ('' + toDate) ||
      el.typology.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) <= ('' + toDate) ||
      ('' + el.date).includes(searchParam.searchFieldValue) && ('' + el.date) <= ('' + toDate) ||
      el.artist.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) <= ('' + toDate))
    }))
    setManuscriptsSlice(manuscripts.filter((el) => {
      return(el.documentTitle.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.dateOfWriting) <= ('' + toDate) ||
      el.typology.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.dateOfWriting) <= ('' + toDate) ||
      ('' + el.dateOfWriting).includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.dateOfWriting) <= ('' + toDate) ||
      el.author.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase) && ('' + el.dateOfWriting) <= ('' + toDate) ||
      el.language.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.dateOfWriting) <= ('' + toDate))
    }))
    setPrintsSlice(prints.filter((el) => {
      return (el.documentTitle.toLowerCase.includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) <= ('' + toDate) ||
      el.typology.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) <= ('' + toDate) ||
      ('' + el.date).includes(searchParam.searchFieldValue) && ('' + el.date) <= ('' + toDate) ||
      el.author.toLowerCase().includes(searchParam.searchFieldValue) && ('' + el.date) <= ('' + toDate) ||
      el.language.toLowerCase().includes(searchParam.searchFieldValue) && ('' + el.date) <= ('' + toDate))
    }))
  } else if(searchParam.searchFieldValue !== "" && ('' + fromDate) !== "" && ('' + toDate) !== "") {
    setImagesSlice(images.filter((el) => {
      return (el.documentTitle.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate) ||
      el.typology.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate) ||
      ('' + el.date).includes(searchParam.searchFieldValue) && ('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate) ||
      el.artist.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate)
      )
    }))

    

    setManuscriptsSlice(manuscripts.filter((el) => {
     
      return (el.documentTitle.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.dateOdWriting) >= ('' + fromDate) && ('' + el.dateOfWriting) <= ('' + toDate) ||
      el.typology.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.dateOfWriting) >= ('' + fromDate) && ('' + el.dateOfWriting) <= ('' + toDate) ||
      ('' + el.dateOfWriting).includes(searchParam.searchFieldValue) && ('' + el.dateOfWriting) >= ('' + fromDate) && ('' + el.dateOfWriting) <= ('' + toDate) ||
      el.author.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.dateOfWriting) >= ('' + fromDate) && ('' + el.dateOfWriting) <= ('' + toDate) ||
      el.language.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.dateOfWriting) >= ('' + fromDate) && ('' + el.dateOfWriting) <= ('' + toDate)
      )
    }))
  

    setPrintsSlice(prints.filter((el) => {
      return(el.documentTitle.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate) ||
      el.typology.toLowerCase().includes(searchParam.searchFieldValue) && ('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate) ||
      ('' + el.date).includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate) ||
      el.author.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate) ||
      el.language.toLowerCase().includes(searchParam.searchFieldValue.toLowerCase()) && ('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate))
    }))
  } 
  else if (searchParam.searchFieldValue ==="" && ('' + fromDate) !=="" && ('' + toDate) !=="") {
    setImagesSlice(images.filter((el) => {
      return(('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate))
    }))
    setManuscriptsSlice(manuscripts.filter((el) => {
      return (('' + el.dateOfWriting) >= ('' + fromDate) && ('' + el.dateOfWriting) <= ('' + toDate) )
    }))
    setPrintsSlice(prints.filter((el) => {
      return (('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate))
    }))
  } else if (searchParam.searchFieldValue ==="" && ('' + fromDate) !=="" && ('' + toDate) ===""){
    setImagesSlice(images.filter((el) => {
      return ('' + el.date >= ('' + fromDate))
    }))
    setManuscriptsSlice(manuscripts.filter((el) => {
      return(('' + el.dateOfWriting) >= ('' + fromDate))
    }))
    setPrintsSlice(prints.filter((el) => { 
      return(('' + el.date) >= ('' + fromDate))
    }))
  } else if (searchParam.searchFieldValue ==="" && ('' + fromDate) ==="" && ('' + toDate) !=="") {
    setImagesSlice(images.filter((el) => {
      return (('' + el.date) <= ('' + toDate))
    }))
    setManuscriptsSlice(manuscripts.filter((el) => {
      return (('' + el.dateOfWriting) <= ('' + toDate))
    }))
    setPrintsSlice(prints.filter((el) => {
      return (('' + el.date) <= ('' + toDate))
    }))
  }
  else {
    setImagesSlice(images.filter((el) => {
      return (('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate))
    }))
    setManuscriptsSlice(manuscripts.filter((el) => {
      return (('' + el.dateOfWriting) >= ('' + fromDate) && ('' + el.dateOfWriting) <= ('' + toDate))
    }))
    setPrintsSlice(prints.filter((el) => {
      return (('' + el.date) >= ('' + fromDate) && ('' + el.date) <= ('' + toDate))
    }))
  }
};


const fromDateHandler = (e) => {
  setFromDate(e.currentTarget.value);
  handleFiltering();
  if (fromDate.length === 4) {
    if (
      (fromDate.length === 4 && parseInt(fromDate) < 1500) ||
      (fromDate.length === 4 && parseInt(fromDate) > 1800)
    ) {
      swal({
        content: (
          <div
            style={{
              fontFamily: "Montserrat",
              fontSize: "12px",
              paddingTop: "20px",
            }}
          >
            <h1
              style={{
                fontSize: "22px",
                fontFamily: "Montserrat",
                fontWeight: "600",
                textAlign: "left",
                marginBottom: "-5px",
                marginTop: "-20px",
              }}
            >
              ERROR
            </h1>
            <hr
              style={{ border: "1px solid #DC251A", marginBottom: "25px" }}
            ></hr>
            <p
              style={{
                textAlign: "left",
                marginLeft: "0px",
                fontSize: "15px",
                marginBottom: "40px",
              }}
            >
              Please, the date must be in the range of 1500 - 1800
            </p>
          </div>
        ),
        button: {
          text: "OK",
          value: true,
          visible: true,
          className: "stylebutton",
          closeModal: true,
        },
      })
    }
  }
};
const toDateHandler = (e) => {
  setToDate(e.currentTarget.value);

 handleFiltering();
  if (
    (toDate.length === 4 && parseInt(toDate) < 1500) ||
    (toDate.length === 4 && parseInt(toDate) > 1800)
  ) {
    swal({
      content: (
        <div
          style={{
            fontFamily: "Montserrat",
            fontSize: "12px",
            paddingTop: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "22px",
              fontFamily: "Montserrat",
              fontWeight: "600",
              textAlign: "left",
              marginBottom: "-5px",
              marginTop: "-20px",
            }}
          >
            ERROR
          </h1>
          <hr
            style={{ border: "1px solid #DC251A", marginBottom: "25px" }}
          ></hr>
          <p
            style={{
              textAlign: "left",
              marginLeft: "0px",
              fontSize: "14px",
              marginBottom: "40px",
            }}
          >
            Please, the date must be respectively in the range of 1500 - 1800
          </p>
        </div>
      ),
      button: {
        text: "OK",
        value: true,
        visible: true,
        className: "stylebutton",
        closeModal: true,
      },
    });
  } else if (parseInt(fromDate) > parseInt(toDate) && toDate.length === 4) {
    swal({
      content: (
        <div
          style={{
            fontFamily: "Montserrat",
            fontSize: "12px",
            paddingTop: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "22px",
              fontFamily: "Montserrat",
              fontWeight: "600",
              textAlign: "left",
              marginBottom: "-5px",
              marginTop: "-20px",
            }}
          >
            ERROR
          </h1>
          <hr
            style={{ border: "1px solid #DC251A", marginBottom: "25px" }}
          ></hr>
          <p
            style={{
              textAlign: "left",
              marginLeft: "0px",
              fontSize: "14px",
              marginBottom: "40px",
            }}
          >
            The research is failed. Please, the date must be respectively in
            the range of 1500 - 1800
          </p>
        </div>
      ),
      button: {
        text: "OK",
        value: true,
        visible: true,
        className: "stylebutton",
        closeModal: true,
      },
    });
  } else if (
    fromDate.length === 4 &&
    toDate.length === 4 &&
    parseInt(fromDate) > parseInt(toDate)
  ) {
    swal({
      content: (
        <div
          style={{
            fontFamily: "Montserrat",
            fontSize: "12px",
            paddingTop: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "22px",
              fontFamily: "Montserrat",
              fontWeight: "600",
              textAlign: "left",
              marginBottom: "-5px",
              marginTop: "-20px",
            }}
          >
            ERROR
          </h1>
          <hr
            style={{ border: "1px solid #DC251A", marginBottom: "25px" }}
          ></hr>
          <p
            style={{
              textAlign: "left",
              marginLeft: "0px",
              fontSize: "14px",
              marginBottom: "40px",
            }}
          >
            The research is failed, the first value can't be minor than the
            second one. Please, type always a value in the range of 1500 -
            1800{" "}
          </p>
        </div>
      ),
      button: {
        text: "OK",
        value: true,
        visible: true,
        className: "stylebutton",
        closeModal: true,
      },
    });
  } else if (fromDate === "1800" && toDate.length === 4 < fromDate) {
    swal({
      content: (
        <div
          style={{
            fontFamily: "Montserrat",
            fontSize: "12px",
            paddingTop: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "22px",
              fontFamily: "Montserrat",
              fontWeight: "600",
              textAlign: "left",
              marginBottom: "-5px",
              marginTop: "-20px",
            }}
          >
            ERROR
          </h1>
          <hr
            style={{ border: "1px solid #DC251A", marginBottom: "25px" }}
          ></hr>
          <p
            style={{
              textAlign: "left",
              marginLeft: "0px",
              fontSize: "14px",
              marginBottom: "40px",
            }}
          >
            The research is failed. The first value can't be greater than the
            second one. The date must be in the range of 1500 - 1800.{" "}
          </p>
        </div>
      ),
      button: {
        text: "OK",
        value: true,
        visible: true,
        className: "stylebutton",
        closeModal: true,
      },
    });
  } else if (toDate.length > 4) {
    swal({
      content: (
        <div
          style={{
            fontFamily: "Montserrat",
            fontSize: "12px",
            paddingTop: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "22px",
              fontFamily: "Montserrat",
              fontWeight: "600",
              textAlign: "left",
              marginBottom: "-15px",
              marginTop: "-20px",
            }}
          >
            ERROR
          </h1>
          <hr
            style={{ border: "1px solid #DC251A", marginBottom: "25px" }}
          ></hr>
          <p
            style={{
              textAlign: "left",
              marginLeft: "0px",
              fontSize: "15px",
              marginBottom: "40px",
            }}
          >
            You can't type more than 4 numbers.
          </p>
        </div>
      ),
      button: {
        text: "OK",
        value: true,
        visible: true,
        className: "stylebutton",
        closeModal: true,
      },
    });
  }
  toDate.match(/[^0-9]/)
    ? setErrorTo("The date can't contain a string")
    : setErrorTo("");
};

const handleChange = (event, newValue) => {
  setValue(newValue);
};


  //MARK: Save Images
  const saveDataImages = async (image) => {
    const newImage = [image];
    const response = await addImage(newImage)
    setImages([...images, ...response])
  }

  //MARK: Save Manuscripts
  const saveDataManuscripts = async (manuscript) => {
    const newManuscript = [manuscript];
    const response = await addManuscript(newManuscript)
    setManuscripts([...manuscripts, ...response])
  }

  //MARK: Save Prints
  const saveDataPrints = async (print) => {
    const newPrint = [print];
    const response = await addPrint(newPrint)
    setPrints([...prints, ...response])
  }


  //refresh page after the post 
  function refreshPage() {
    window.location.reload(true);
  }

  // get the images, manuscripts and prints.
  useEffect(() => {
    const fetchData = async () => {
      const result = await axiosClient(
        `http://discompose.unina.it/api/events/${record_id}/images`,
      );
      const resultManoscritti = await axiosClient(
        `http://discompose.unina.it/api/events/${record_id}/manuscripts`,
      );
      const resultStampe = await axiosClient(
        `http://discompose.unina.it/api/events/${record_id}/prints`,
      );
      setImages([...images, ...result.data]);
      setManuscripts([...manuscripts, ...resultManoscritti.data]);
      setPrints([...prints, ...resultStampe.data]);
    };
    fetchData();
  }, []);
//MARK: delete image
const handleDeleteImage = async imageId => {
  const resp = await deleteSingleImage(imageId)
  if (resp) {
    const updateImages = images.filter(el => el.id !== imageId)
    setImages(updateImages)

  }
}

//MARK: delete manuscript
const handleDeleteManuscript = async manuscriptId => {
  const resp = await deleteSingleManuscript(manuscriptId)
  if (resp) {
    const updateManuscripts = manuscripts.filter(el => el.id !== manuscriptId)
    setManuscripts(updateManuscripts)
  }
}

//MARK: delete print
const handleDeletePrint = async printId => {
  const resp = await deleteSinglePrint(printId)
  if (resp) {
    const updatePrints = prints.filter(el => el.id !== printId)
    setPrints(updatePrints)
  }
}

//MARK: handle update image
const handleUpdateImage = async (imageId, dati) => {

  const newData = { ...dati, eventRecord: { id: record_id } };
  const resp = await updateSingleImage(imageId, newData)
  

  if (resp) {
    const upImages = images.reduce((acc, next) => {
      if (next.id === imageId) {
        return [...acc, resp];
      }
      return [...acc, next];
    }, []);
    setImages(upImages)
  }
}

//MARK: handle update manuscript
const handleUpdateManuscript = async (manuscriptId, dati) => {
  const newData = { ...dati, eventRecord: { id: record_id } };
  const resp = await updateSingleManuscript(manuscriptId, newData)
  if (resp) {
    const upManuscripts = manuscripts.reduce((acc, next) => {
      if (next.id === manuscriptId) {
        return [...acc, resp];
      }
      return [...acc, next];
    }, []);
    setManuscripts(upManuscripts)
  }
}

//MARK: handle update print
const handleUpdatePrint = async (printId, dati) => {
  const newData = { ...dati, eventRecord: { id: record_id } };
  const resp = await updateSinglePrint(printId, newData)
  if (resp) {
    const upPrints = prints.reduce((acc, next) => {
      if (next.id === printId) {
        return [...acc, resp];
      }
      return [...acc, next];
    }, []);
    setPrints(upPrints)
  }
}


useEffect(() => {
  if (searchParam === "" && ('' + fromDate) === "" && ('' + toDate) === "") {
    setImagesSlice(images);
    setManuscriptsSlice(manuscripts);
    setPrintsSlice(prints);
  } else {
    handleFiltering(searchParam);
  }
}, [searchParam, fromDate, toDate, images, manuscripts, prints]);

const history = useHistory()

const goBack = () => {
  history.goBack()
}

  return (
    <div className={classes.root} style={{ marginTop: '50px' }}>
      <div style={{ marginTop: '30px', marginRight: "4%", marginLeft: "4%" }}>
       <Grid container >
       <Grid item lg={3} md={4} sm={12} xs={12}>
       <div  onClick={() => goBack()} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', cursor: 'pointer'}}>
            <div><ArrowBackIosIcon style={{ width: '26px', color: '#E93E24', marginBottom: '35px', fontSize: '31px', cursor: 'pointer' }} /></div>
            <h1 style={{ fontFamily: 'Montserrat', color: 'black',  fontSize: '18px', color: '#E93E24', marginLeft: '-5px', marginBottom: '35px', fontWeight: '500' }}>Back</h1>
        </div>
          </Grid>
          <Grid item lg={6} md={4} sm={12} xs={12}>
        <div>
        <h1 style={{ fontFamily: 'Montserrat', color: 'black',  fontSize: '24px', textAlign: 'center', fontWeight: '700'}}>{props.location.state.place.toUpperCase()}'S {props.location.state.eventType.toUpperCase()} {props.location.state.eventDate}</h1>
        </div>
        </Grid>  <Grid item lg={4} md={4} sm={12} xs={12}>
        <div>
        <h1 style={{ fontFamily: 'Montserrat', color: 'black',  fontSize: '26px', textAlign: 'center', fontWeight: '700'}}></h1>
        </div>
        </Grid>
        </Grid>
      </div>
      <div style={{  marginRight: "8%", marginLeft: "8%" }}>
      <Grid container >
      <SimpleAccordion place = {props.location.state.place} eventType = {props.location.state.eventType} eventDate = {props.location.state.eventDate}  eventDescription = {props.location.state.eventDescription} />
       
        <Grid item lg={3} md={3} sm={12} xs={12}>
          <div style={{marginTop: '38px'}}>
        <Searchbar  searchFieldValue={searchParam.searchFieldValue} setSearchParam={setSearchParam} searchParam={searchParam} vaule={searchParam} />
        </div>
        </Grid>

        <Grid item lg={3} md={3} sm={12} xs={12}>
        <p style={{fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '500', marginBottom: '2px'}}>FROM YEAR</p>
          <InputBase style={{ backgroundColor: '#F0F0F0', marginTop: '0px',  height: '35px',  paddingLeft: '8px', paddingTop: '5px', paddingBottom: '3px', fontFamily: 'Montserrat', fontWeight: '500', fontSize: '15px', float: 'left' }}
            type= "number"
            placeholder="1500"
            inputProps={{ 'aria-label': 'search' }}
            onChange={fromDateHandler}
            value={fromDate}
          />
        </Grid>
   
        <Grid item lg={3} md={3} sm={12} xs={12}>
        <p style={{fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '500', marginBottom: '2px'}}>TO YEAR</p>
          <InputBase style={{ backgroundColor: '#F0F0F0', marginTop: '0px', height: '35px', paddingLeft: '8px', paddingTop: '5px', paddingBottom: '3px', fontFamily: 'Montserrat', marginBottom: '30px', fontWeight: '500', fontSize: '15px', float: 'left' }}
            type= "number"
            placeholder="1800"
            inputProps={{ 'aria-label': 'search' }}
            onChange={toDateHandler}
            value={toDate}

          />
        </Grid>

      </Grid>

      <AppBar style={{ backgroundColor: 'white',  border: '1px solid #F2F2F2', marginTop: '10px' }} position="static" elevation={0}>
        <Tabs
          variant="fullWidth"
          value={value}
          onChange={handleChange}
          aria-label="nav tabs example"
          indicatorColor="primary" classes={{ indicator: classes.indicator }}
        // TabIndicatorProps={{style: {background:'#DC251A'}}}
        >
          <LinkTab className={classes.label} label="IMAGES" href="/drafts" {...a11yProps(0)} />
          <LinkTab className={classes.label} label="MANUSCRIPTS" href="/trash" {...a11yProps(1)} />
          <LinkTab className={classes.label} label="PRINTS" href="/spam" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel style={{ width: "103%", marginLeft: '-20px' }} value={value} index={0}>
        <ImageTable images={imagesSlice} deleteImage={handleDeleteImage} UpdateImage={handleUpdateImage} />
      </TabPanel>
      <TabPanel style={{ width: "103%", marginLeft: '-20px' }} value={value} index={1}>
        <ManuscriptTable manuscripts={manuscriptsSlice} deleteManuscript={handleDeleteManuscript} UpdateManuscript={handleUpdateManuscript} />
      </TabPanel>
      <TabPanel style={{ width: "103%", marginLeft: '-20px' }} value={value} index={2}>
        <PrintTable prints={printsSlice} deletePrint={handleDeletePrint} UpdatePrint={handleUpdatePrint} />
      </TabPanel>
      </div>
    </div>
  );
}